export default function (context) {
    $(context).find('.item-position').each(function (index, position) {
        $(position).text(++index);
    });
}
